"use client";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchDashboard } from "../services/dashboardService";

export function useDashboard(initialPage: number = 1) {
  const showToast = useToast();
  const queryClient = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);
  const [filters, setFilters] = useState({
    protocol: "",
    document: "",
    startDate: "",
    endDate: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters); 

  const DashboardQuery = useQuery<
    { items: any; },
    Error,
    { Dashboard: any; }
  >({
    queryKey: ["Dashboard", pageNumber, appliedFilters],
    queryFn: () => fetchDashboard(),
    select: (apiResponse: any) => {
      console.log("apiResponse", apiResponse);
      const items = apiResponse.data || [];
      return { Dashboard: items };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar.");
    },
  });

  return {
    Dashboard: DashboardQuery.data?.Dashboard || [],
    isLoading: DashboardQuery.isLoading,

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    filters,
    setFilters,
    setAppliedFilters,
    refetchDashboard: DashboardQuery.refetch,
  };
}
